// extracted by mini-css-extract-plugin
export default {"sticky_btn":"sticky-btn_sticky_btn__67L6z"};